"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelationStyled = void 0;
exports.RelationStyled = styled.button `
&.octo {
  display: flex;
  flex-flow: column nowrap;
  gap: 0.5em;
  align-items: center;
  justify-content: stretch;
  cursor: pointer;

  >.image {
    width: 7em;
    height: 7em;
  }

  >.title {
    font-weight: 600;
  }

  >.text {
    text-align: center;

    > span {
      font-size: 0.875em;
    }
  }
}
`;
//# sourceMappingURL=Relation.styled.js.map